import { PillIcon } from './PillIcon';

/**
 * author: Austin Andrews
 * id 6487E4ED-C501-416C-9DCE-1B7C1F676050
 * name pill
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pill.svg
 * tags
 * - Medical / Hospital 
 */
export const CapsuleIcon = PillIcon;
export default CapsuleIcon